import React, { useMemo } from 'react';
import { moment } from 'moment';
import { Grid, FormLabel } from '@material-ui/core';
import BreadCrumbs from '../../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../GijgoForReportsScreen';
import { useHistory } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { AppStorage } from '../../../../../Core/Service/storage-service';

const baseColumns = [
    { field: 'agedMeasureDescription', sortable: false, title: `Department`, width: 180, filterable: false, align: 'left' },
    {
        field: 'provisionRequired',
        sortable: false,
        title: `Provision Required`,
        width: 120,
        showColumnTotal: true,
        align: 'right',
        filterable: false,
        isCurrency: true
    },
    { field: 'totalAmount', sortable: false, title: `Total`, width: 120, showColumnTotal: true, align: 'right', filterable: false, isCurrency: true },
    { field: 'currentMonthTotal', sortable: false, title: `Current`, width: 120, showColumnTotal: true, align: 'right', filterable: false },
    {
        field: 'oneMonthTotal',
        sortable: false,
        title: `1 Month`,
        width: 150,
        showColumnTotal: true,
        align: 'right',
        filterable: false
    },
    { field: 'twoMonthsTotal', sortable: false, title: `2 Month`, width: 120, showColumnTotal: true, align: 'right', filterable: false },
    { field: 'threeMonthsTotal', sortable: false, title: `3 Month`, width: 120, showColumnTotal: true, align: 'right', filterable: false },
    {
        field: 'fourMonthsAndOverTotal',
        sortable: false,
        title: '4+ Month',
        width: 120,
        showColumnTotal: true,
        align: 'right',
        filterable: false
    },
    {
        field: 'unallocatedItemsTotal',
        title: 'Unallocated',
        width: 120,
        showColumnTotal: true,
        align: 'right',
        filterable: false,
        sortable: false
    }
];
const crumbs = (menuPermissionCounter) => {
    let list = [{ name: 'Home', path: '/' }];
    if (menuPermissionCounter !== 1) {
        list.push({ name: 'Reports', path: '/ReportsDashboard' });
    }
    list.push({ name: 'Aged Measures', path: '/AgedMeasures' }, { name: 'Cash By Department', active: true });
    return list;
};

let addCommas = (val) => {
    return val ? `£${val.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}` : '£0.00';
};

const CashByDepartment = (props) => {
    let menuPermissionCounter = AppStorage.menuPermissionCounter();
    const history = useHistory();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let Measuredesc = decodeURIComponent(params.get('measuredesc') || '');
    let MeasureID = params.get('MeasureID') || '';
    const redirectToScreens = (value, record, MeasureID, field) => {
        let searchQuery = `?&measuredesc=${Measuredesc}&MeasureID=${MeasureID}&month=${field.month == 0 ? 0 : field.month || ''}&unallocated=${
            field.unallocated || ''
        }&cashAccountTypeID=${record.agedMeasureID || ''}&Department=${record.agedMeasureDescription || ''}`;
        history.push({
            pathname: '/AgedMeasures/GetAgedMeasuresRanMWarrantyCashGen',
            search: searchQuery
        });
    };

    const editButton = (field) => (value, record) => {
        let isClickable = record.accessAllowed.trim() === 'Y';
        const spn = document.createElement('span');
        const lnk = (
            <Grid
                title={value}
                onClick={isClickable ? () => redirectToScreens(value, record, MeasureID, field) : ''}
                style={{ cursor: isClickable ? 'pointer' : '' }}
            >
                {value}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };
    const monthsActionHandler = (field) => (value, record) => {
        let isClickable = record.accessAllowed.trim() === 'Y';
        const spn = document.createElement('span');
        const lnk = (
            <Grid
                title={field.toolTipLabel ? record[field.toolTipLabel] : value}
                onClick={isClickable ? () => redirectToScreens(value, record, MeasureID, field) : ''}
                style={{ cursor: isClickable ? 'pointer' : '' }}
            >
                {addCommas(value)}
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    // const totalAmountWrapper = (value, record) => {
    //     const spn = document.createElement('span');
    //     const lnk = (
    //         <Grid>
    //             {addCommas(record.currentMonthTotal + record.oneMonthTotal + record.twoMonthsTotal + record.threeMonthsTotal + record.fourMonthsAndOverTotal)}
    //         </Grid>
    //     );
    //     ReactDOM.render(lnk, spn);
    //     return spn;
    // };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let departmentCol = tempCols.find((element) => element.field === 'agedMeasureDescription');
        let currentMonthTotalCol = tempCols.find((element) => element.field === 'currentMonthTotal');
        // let totalAmount = tempCols.find((element) => element.field === 'totalAmount');
        let oneMonthTotalCol = tempCols.find((element) => element.field === 'oneMonthTotal');
        let twoMonthTotalCol = tempCols.find((element) => element.field === 'twoMonthsTotal');
        let threeMonthTotalCol = tempCols.find((element) => element.field === 'threeMonthsTotal');
        let fourPlusMonthTotalCol = tempCols.find((element) => element.field === 'fourMonthsAndOverTotal');
        let unallocatedTotalCol = tempCols.find((element) => element.field === 'unallocatedItemsTotal');
        if (departmentCol) {
            departmentCol.renderer = editButton({});
        }
        // if (totalAmount) {
        //     totalAmount.renderer = totalAmountWrapper;
        // }
        if (currentMonthTotalCol) {
            currentMonthTotalCol.renderer = monthsActionHandler({ month: 0, toolTipLabel: 'currentMonthCount' });
        }
        if (oneMonthTotalCol) {
            oneMonthTotalCol.renderer = monthsActionHandler({ month: 1, toolTipLabel: 'oneMonthCount' });
        }
        if (twoMonthTotalCol) {
            twoMonthTotalCol.renderer = monthsActionHandler({ month: 2, toolTipLabel: 'twoMonthsCount' });
        }
        if (threeMonthTotalCol) {
            threeMonthTotalCol.renderer = monthsActionHandler({ month: 3, toolTipLabel: 'threeMonthsCount' });
        }
        if (fourPlusMonthTotalCol) {
            fourPlusMonthTotalCol.renderer = monthsActionHandler({ month: 4, toolTipLabel: 'fourMonthsAndOverCount' });
        }
        if (unallocatedTotalCol) {
            unallocatedTotalCol.renderer = monthsActionHandler({ unallocated: 1, toolTipLabel: 'unallocatedItemsCount' });
        }
        return tempCols;
    }, [MeasureID]);

    const baseUrl = `AgedMeasures/GetCashByDepartment?MeasureID=${MeasureID}`;
    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs(menuPermissionCounter)} />
            <Grid item container spacing={1} xs={12}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data?.list.map((p) => {
                                console.log(p, 'p');
                                return {
                                    ...p,
                                    totalAmount: p.currentMonthTotal + p.oneMonthTotal + p.twoMonthsTotal + p.threeMonthsTotal + p.fourMonthsAndOverTotal
                                };
                            }),
                            total: res?.data?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isShowTotal={true}
                        // hidePagination={true}
                        hideFilterRow={true}
                        downloadName="Cash By Department"
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default CashByDepartment;
